import {selectBook} from "../reducers";

export const selectCartBooks = rootState => rootState.cart?.map(bookId => selectBook(bookId)(rootState)) ?? []; // TODO: FIX STORAGE VERSIONING
export const selectCartCount = rootState => rootState.cart?.length ?? 0; // TODO: FIX STORAGE VERSIONING
